import '../sass/page-hero.scss';

(() => {
    const heroes = document.querySelectorAll('.page-hero__image--circle');

    if (!heroes.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    heroes.forEach((hero) => {
        const frames = [...hero.querySelectorAll('.page-hero__image__frame')];

        if (frames.length < 2) return;

        let index = 0;

        window.setInterval(() => {
            frames[index].classList.remove('is-active');
            index = (index + 1) % frames.length;
            frames[index].classList.add('is-active');
        }, 3000);
    });
})();
